import AssetListView from "@/components/AssetListView";
import { Outlet } from "react-router";

const MetadataFlowPage = () => {
  return (
    <div className="mx-space125 flex">
      <div className="w-[23.4rem]">
        <AssetListView />
      </div>
      <div className="vertical-divider" />
      <div className="flex-1">
        <Outlet />
      </div>
    </div>
  );
};

export default MetadataFlowPage;
